module.exports = __webpack_public_path__ + "static/carousel-general-cb-68d88d16d125bcf9785e0440f602aa10.png";